export default __webpack_public_path__ + "static/media/Animals04.1ae55746.jpg";